export enum ContractRequestPermission {
    IsCreator = 'Creator of Contract Request',
    IsRecruitor = 'Recruiter listed on Contract Request',
    TravelContracts = 'Has security access to Travel Contracts',
    TravelRecruiting = 'Has security access to Travel Recruiting'
}
